import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Box, Typography, Link, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, RadioGroup, Radio, FormControlLabel,  } from '@mui/material';
import axios from 'axios';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function Page2SubPageD() {
  const { mode } = useParams();
 const history = useHistory();
 const location = useLocation();
 const [openDialog, setOpenDialog] = useState(false);
 const [activePostId, setActivePostId] = useState(null);
 const [voteType, setVoteType] = useState(null); 
 const [comment, setComment] = useState("");

 const [undoDialogOpen, setUndoDialogOpen] = useState(false);
 const [pendingUndoPostId, setPendingUndoPostId] = useState(null);
 const [pendingUndoPost, setPendingUndoPost] = useState(null);
 const [openVotersDialog, setOpenVotersDialog] = useState(false);
 const [dialogTitle, setDialogTitle] = useState("");
 const [activeVoters, setActiveVoters] = useState([]);
 const [open, setOpen] = useState(false);
 const [votersDialogOpen, setVotersDialogOpen] = useState(false);
 const [selectedOptionVoters, setSelectedOptionVoters] = useState([]);
 const [selectedPost, setSelectedPost] = useState(null);
 const [newPost, setNewPost] = useState('');

 const [loggedInUser, setLoggedInUser] = useState(null);
 useEffect(() => {
    axios.get("/user/me")
      .then(res => setLoggedInUser(res.data))
      .catch(() => setLoggedInUser(null));
  }, []);

 const [govComments, setGovComments] = useState([]);
 /*useEffect(() => {
     axios.get('/api/gov-comments/followed')
     .then(res => setGovComments(res.data))
     .catch(err => console.error(err));
 }, []);*/
  /*useEffect(() => {
    let endpoint = "/api/gov-comments/followed";

    if (mode === "popular") {
      endpoint = "/api/topGov";
    }

    axios.get(endpoint)
      .then(res => setGovComments(res.data))
      .catch(err => console.error(err));

  }, [mode]);*/ 
  // State — replace your existing govComments useState
const [cursor, setCursor] = useState(null);
const [hasMore, setHasMore] = useState(true);
const [feedLoading, setFeedLoading] = useState(false);

// Ref to avoid stale closure in IntersectionObserver
const feedLoadingRef = useRef(false);
const hasMoreRef = useRef(true);
const cursorRef = useRef(null);

const fetchFollowedGov = async (reset = false) => {
  if (feedLoadingRef.current || !hasMoreRef.current) return;

  feedLoadingRef.current = true;
  setFeedLoading(true);

  try {
    const res = await axios.get("/api/gov-comments/followed", {
      params: {
        cursor: reset ? null : cursorRef.current,
        limit: 1,
      },
    });

    const { posts, nextCursor, hasMore: more } = res.data;

    setGovComments(prev => reset ? posts : [...prev, ...posts]);
    cursorRef.current = nextCursor;
    hasMoreRef.current = more;
    setCursor(nextCursor);
    setHasMore(more);
  } catch (err) {
    console.error("Error loading followed gov feed", err);
  } finally {
    feedLoadingRef.current = false;
    setFeedLoading(false);
  }
};

// Reset and refetch when switching to followed mode
useEffect(() => {
  if (mode === "popular") return;
  // Reset all pagination state
  cursorRef.current = null;
  hasMoreRef.current = true;
  setGovComments([]);
  setCursor(null);
  setHasMore(true);
  fetchFollowedGov(true);
}, [mode]);

// Popular mode fetch — unchanged, no pagination
useEffect(() => {
  if (mode !== "popular") return;
  axios.get("/api/topGov")
    .then(res => setGovComments(res.data))
    .catch(err => console.error(err));
}, [mode]);

// IntersectionObserver for infinite scroll
const observer = useRef();
const lastPostRef = useCallback(node => {
  if (feedLoading) return;
  if (observer.current) observer.current.disconnect();
  observer.current = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && hasMoreRef.current && !feedLoadingRef.current) {
      fetchFollowedGov();
    }
  });
  if (node) observer.current.observe(node);
}, [feedLoading]);

const toggleBillVote = async (billId) => {
   try {
       const res = await axios.post(`/bill/${billId}/upvote`);
       const { upvotes, voted } = res.data;


       setGovComments(prevBills => {
           const updated = prevBills.map(bill =>
               bill._id === billId
               ? { ...bill, upvoteCount: upvotes, voted }
               : bill
           );


       // Sort again after update
       return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
       });
   } catch (err) {
       console.error('Error toggling vote:', err);
   }
   };


const toggleScotusVote = async (scotusCaseId) => {
  try {
      const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
      const { upvotes, voted } = res.data;


      setGovComments(prevCases => {
          const updated = prevCases.map(scotusCase =>
              scotusCase._id === scotusCaseId
              ? { ...scotusCase, upvoteCount: upvotes, voted }
              : scotusCase
          );


      // Sort again after update
      return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
      });
  } catch (err) {
      console.error('Error toggling vote:', err);
  }
  };


const toggleCalPropVote = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/upvote`);
           const { upvotes, voted } = res.data;


           setGovComments(prevCalProp => ({
               ...prevCalProp,
           upvoteCount: upvotes,
           voted,
           }));


       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


const toggleStateBillVote = async (calBillId) => {
 try {
     const res = await axios.post(`/calBill/${calBillId}/upvote`);
     const { upvotes, voted } = res.data;


     setGovComments(prevCalBills => {
         const updated = prevCalBills.map(calBill =>
             calBill._id === calBillId
             ? { ...calBill, upvoteCount: upvotes, voted }
             : calBill
         );


     // Sort again after update
     return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
     });
 } catch (err) {
     console.error('Error toggling vote:', err);
 }
 };


/*const toggleBillPass = async (billId) => {
       try {
           const res = await axios.post(`/bill/${billId}/pass`);
           const { upvotes, billVoted } = res.data;


           setGovComments(prev =>
               prev.map(bill => bill._id === billId ? { ...bill, passCount: upvotes, billVoted } : bill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };*/
   const toggleBillPass = async (billId, commentId) => {
      try {
        const res = await axios.post(
          `/bill/${billId}/pass`,
          { commentId }
        );

        const { upvotes } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== billId) return p;
              return {
                ...p,
                passCount: upvotes,
                votedBill: true,
                votedSide:       'pass',
              };
            })
          );
        /*
        const { upvotes, billVoted } = res.data;

        setGovComments(prev =>
          prev.map(bill => {
            if (bill._id !== billId) return bill;

            return {
              ...bill,
              passCount: upvotes,
              billVoted,

              billVoters: [
                ...(bill.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),
                {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
              ],

              passPowerVotes: [
                ...(bill.passPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),
                {
                  user: {
                    _id: loggedInUser._id,
                    username: loggedInUser.username,
                    first_name: loggedInUser.first_name,
                    last_name: loggedInUser.last_name,
                    profileImageUrl: loggedInUser.profileImageUrl,
                    tier: loggedInUser.tier,
                  },
                  comment: commentId,
                },
              ],

              noPassPowerVotes: (bill.noPassPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
            };
          })
        );*/
      } catch (err) {
        console.error("Error toggling vote:", err);
      }
    };


   /*const toggleBillNoPass = async (billId) => {
       try {
           const res = await axios.post(`/bill/${billId}/noPass`);
           const { upvotes, billVoted } = res.data;


           setGovComments(prev =>
               prev.map(bill => bill._id === billId ? { ...bill, noPassCount: upvotes, billVoted } : bill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
  };*/
  const toggleBillNoPass = async (billId, commentId) => {
      try {
        const res = await axios.post(
          `/bill/${billId}/noPass`,
          { commentId }
        );

        const { upvotes } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== billId) return p;
              return {
                ...p,
                noPassCount: upvotes,
                votedBill: true,
                votedSide:       'no pass',
              };
            })
          );
        /*
        const { upvotes, billVoted } = res.data;

        setGovComments(prev =>
          prev.map(bill => {
            if (bill._id !== billId) return bill;

            return {
              ...bill,

              // update count
              noPassCount: upvotes,
              billVoted,

              // update voters (dedupe user)
              billVoters: [
                ...(bill.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),
                {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
              ],

              // add noPass vote (deduped)
              noPassPowerVotes: [
                ...(bill.noPassPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),
                {
                  user: {
                    _id: loggedInUser._id,
                    username: loggedInUser.username,
                    first_name: loggedInUser.first_name,
                    last_name: loggedInUser.last_name,
                    profileImageUrl: loggedInUser.profileImageUrl,
                    tier: loggedInUser.tier,
                  },
                  comment: commentId,
                },
              ],

              // remove from pass side
              passPowerVotes: (bill.passPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
            };
          })
        );*/
      } catch (err) {
        console.error("Error toggling vote:", err);
      }
    };

/*const toggleForPetitioner = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`);
           const { upvotes, scotusCaseVoted } = res.data;




           setGovComments(prev =>
               prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, petitionerCount: upvotes, scotusCaseVoted } : scotusCase)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };*/
  /*const toggleForPetitioner = async (scotusCaseId, commentId) => {
    try {
      const res = await axios.post(
        `/scotusCase/${scotusCaseId}/petitioner`,
        { commentId }
      );

      const { upvotes, scotusCaseVoted } = res.data;

      setGovComments(prev =>
        prev.map(scotusCase => {
          if (scotusCase._id !== scotusCaseId) return scotusCase;

          return {
            ...scotusCase,
            petitionerCount: upvotes,
            scotusCaseVoted,

            // update voters
            scotusCaseVoters: [
              ...(scotusCase.scotusCaseVoters || []).filter(
                v => !isSameUser(v, loggedInUser._id)
              ),
              {
                _id: loggedInUser._id,
                username: loggedInUser.username,
                first_name: loggedInUser.first_name,
                last_name: loggedInUser.last_name,
                profileImageUrl: loggedInUser.profileImageUrl,
                tier: loggedInUser.tier,
              },
            ],

            // add petitioner vote (deduped)
            petitionerPowerVotes: [
              ...(scotusCase.petitionerPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
              {
                user: {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
                comment: commentId,
              },
            ],

            // remove from respondent side
            respondentPowerVotes: (scotusCase.respondentPowerVotes || []).filter(
              v => !isSameUser(v.user, loggedInUser._id)
            ),
          };
        })
      );
    } catch (err) {
      console.error("Error toggling vote:", err);
    }
  };*/
  const toggleForPetitioner = async (scotusCaseId, commentId) => {
    try {
      const res = await axios.post(
        `/scotusCase/${scotusCaseId}/petitioner`,
        { commentId }
      );
      const { upvotes } = res.data;
      setGovComments(prev =>
        prev.map(p => {
          if (p._id !== scotusCaseId) return p;
          return {
            ...p,
            petitionerCount: upvotes,
            votedScotusCase: true,
            votedSide:       'petitioner',
          };
        })
      );
    } catch (err) {
      console.error("Error toggling vote:", err);
    }
  };



 /*const toggleForRespondent = async (scotusCaseId) => {
       try {
           const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`);
           const { upvotes, scotusCaseVoted } = res.data;




           setGovComments(prev =>
               prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, respondentCount: upvotes, scotusCaseVoted } : scotusCase)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };*/
   /*
   const toggleForRespondent = async (scotusCaseId, commentId) => {
      try {
        const res = await axios.post(
          `/scotusCase/${scotusCaseId}/respondent`,
          { commentId }
        );

        const { upvotes, scotusCaseVoted } = res.data;

        setGovComments(prev =>
          prev.map(scotusCase => {
            if (scotusCase._id !== scotusCaseId) return scotusCase;

            return {
              ...scotusCase,
              respondentCount: upvotes,
              scotusCaseVoted,

              // update voters
              scotusCaseVoters: [
                ...(scotusCase.scotusCaseVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),
                {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
              ],

              // add respondent vote (deduped)
              respondentPowerVotes: [
                ...(scotusCase.respondentPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),
                {
                  user: {
                    _id: loggedInUser._id,
                    username: loggedInUser.username,
                    first_name: loggedInUser.first_name,
                    last_name: loggedInUser.last_name,
                    profileImageUrl: loggedInUser.profileImageUrl,
                    tier: loggedInUser.tier,
                  },
                  comment: commentId,
                },
              ],

              // remove from petitioner side
              petitionerPowerVotes: (scotusCase.petitionerPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
            };
          })
        );
      } catch (err) {
        console.error("Error toggling vote:", err);
      }
    };*/
    const toggleForRespondent = async (scotusCaseId, commentId) => {
      try {
        const res = await axios.post(
          `/scotusCase/${scotusCaseId}/respondent`,
          { commentId }
        );
        const { upvotes } = res.data;
        setGovComments(prev =>
          prev.map(p => {
            if (p._id !== scotusCaseId) return p;
            return {
              ...p,
              respondentCount: upvotes,
              votedScotusCase: true,
              votedSide:       'respondent',
            };
          })
        );
      } catch (err) {
        console.error("Error toggling vote:", err);
      }
    };


const toggleStateBillNoPass = async (calBillId, commentId) => {
      try {
          /*const res = await axios.post(`/calBill/${calBillId}/noPass`);
          const { upvotes, stateBillVoted } = res.data;


          setGovComments(prev =>
              prev.map(calBill => calBill._id === calBillId ? { ...calBill, noPassCount: upvotes, stateBillVoted } : calBill)
          );*/
          const res = await axios.post(
          `/calBill/${calBillId}/noPass`,
          { commentId }
        );

        const { upvotes } = res.data;
        setGovComments(prev =>
          prev.map(p => {
            if (p._id !== calBillId) return p;
            return {
              ...p,
              noPassCount: upvotes,
              votedStateBill: true,
              votedSide:       'no pass',
            };
          })
        );
        /*
        const { upvotes, billVoted } = res.data;

        setGovComments(prev =>
          prev.map(bill => {
            if (bill._id !== calBillId) return bill;

            return {
              ...bill,

              // update count
              noPassCount: upvotes,
              billVoted,

              // update voters (dedupe user)
              billVoters: [
                ...(bill.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),
                {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
              ],

              // add noPass vote (deduped)
              noPassPowerVotes: [
                ...(bill.noPassPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),
                {
                  user: {
                    _id: loggedInUser._id,
                    username: loggedInUser.username,
                    first_name: loggedInUser.first_name,
                    last_name: loggedInUser.last_name,
                    profileImageUrl: loggedInUser.profileImageUrl,
                    tier: loggedInUser.tier,
                  },
                  comment: commentId,
                },
              ],

              // remove from pass side
              passPowerVotes: (bill.passPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
            };
          })
        );*/
      } catch (err) {
          console.error('Error toggling vote:', err);
      }
  };


const toggleStateBillPass = async (calBillId, commentId) => {
      try {
          /*const res = await axios.post(`/calBill/${calBillId}/pass`);
          const { upvotes, stateBillVoted} = res.data;

          setGovComments(prev =>
              prev.map(calBill => calBill._id === calBillId ? { ...calBill, passCount: upvotes, stateBillVoted } : calBill)
          );*/
          const res = await axios.post(
          `/calBill/${calBillId}/pass`,
          { commentId }
        );
        
        const { upvotes } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== calBillId) return p;
              return {
                ...p,
                passCount: upvotes,
                votedStateBill: true,
                votedSide:       'pass',
              };
            })
          );
        /*
        const { upvotes, billVoted } = res.data;

        setGovComments(prev =>
          prev.map(bill => {
            if (bill._id !== calBillId) return bill;

            return {
              ...bill,
              passCount: upvotes,
              billVoted,

              billVoters: [
                ...(bill.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),
                {
                  _id: loggedInUser._id,
                  username: loggedInUser.username,
                  first_name: loggedInUser.first_name,
                  last_name: loggedInUser.last_name,
                  profileImageUrl: loggedInUser.profileImageUrl,
                  tier: loggedInUser.tier,
                },
              ],

              passPowerVotes: [
                ...(bill.passPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),
                {
                  user: {
                    _id: loggedInUser._id,
                    username: loggedInUser.username,
                    first_name: loggedInUser.first_name,
                    last_name: loggedInUser.last_name,
                    profileImageUrl: loggedInUser.profileImageUrl,
                    tier: loggedInUser.tier,
                  },
                  comment: commentId,
                },
              ],

              noPassPowerVotes: (bill.noPassPowerVotes || []).filter(
                v => !isSameUser(v.user, loggedInUser._id)
              ),
            };
          })
        );*/
      } catch (err) {
          console.error('Error toggling vote:', err);
      }
  };


const toggleNo = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/no`);
           const { upvotes, calPropVoted } = res.data;




           setGovComments(prevCalProp => ({
               ...prevCalProp,
               noCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const toggleYes = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/yes`);
           const { upvotes, calPropVoted} = res.data;


           setGovComments(prevCalProp => ({
               ...prevCalProp,
               yesCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




  const handleSubmitBillVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }

       try {
           const commentRes = await axios.post(
                `/bill/${activePostId}/comment`,
                { text: comment }
            );

           const commentId = commentRes.data._id; 

           //const getCommentRes = await axios.get('/api/gov-comments/followed');
           //setGovComments(getCommentRes.data);
           /*if (mode === "popular") {
              const getCommentRes = await axios.get('/api/topGov');
              setGovComments(getCommentRes.data);
           } else {
              const getCommentRes = await axios.get('/api/gov-comments/followed');
              setGovComments(getCommentRes.data);
           }*/

           if (voteType === "Pass") {
               await toggleBillPass(activePostId, commentId);
           } else {
               await toggleBillNoPass(activePostId, commentId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };


    const handleSubmitScotusVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }

       try {
           const commentRes = await axios.post(
                `/scotusCase/${activePostId}/comment`,
                { text: comment }
            );

           const commentId = commentRes.data._id; 

           /*if (mode === "popular") {
              const getCommentRes = await axios.get('/api/topGov');
              setGovComments(getCommentRes.data);
           } else {
              const getCommentRes = await axios.get('/api/gov-comments/followed');
              setGovComments(getCommentRes.data);
           }*/

           if (voteType === "For Petitioner") {
               await toggleForPetitioner(activePostId, commentId);
           } else {
               await toggleForRespondent(activePostId, commentId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
    };


const handleSubmitStateBillVote = async () => {
      if (!voteType || !comment.trim() || !activePostId) {
          alert("Please choose vote type and enter a comment.");
          return;
      }

      try {
          //await axios.post(`/calBill/${activePostId}/comment`, { text: comment });
          const commentRes = await axios.post(
                `/calBill/${activePostId}/comment`,
                { text: comment }
            );

           const commentId = commentRes.data._id; 

           //const getCommentRes = await axios.get('/api/gov-comments/followed');
           //setGovComments(getCommentRes.data);
           /*if (mode === "popular") {
              const getCommentRes = await axios.get('/api/topGov');
              setGovComments(getCommentRes.data);
           } else {
              const getCommentRes = await axios.get('/api/gov-comments/followed');
              setGovComments(getCommentRes.data);
           }*/

          if (voteType === "No Pass") {
              await toggleStateBillNoPass(activePostId, commentId);
          } else {
              await toggleStateBillPass(activePostId, commentId);
          }
          setOpenDialog(false);
          setComment("");
          setVoteType(null);
      } catch (err) {
          console.error(err);
      }
  };


const handleSubmitCalPropVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }


       try {
           await axios.post(`/calProp/${activePostId}/comment`, { text: comment });


           if (voteType === "No") {
               await toggleNo(activePostId);
           } else {
               await toggleYes(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };



 //let currPostType = "";
 const [currPostType, setCurrPostType] = useState("");
 const handleOpenDialog = (postId, postType) => {
       setCurrPostType(postType);
       setActivePostId(postId);
       setOpenDialog(true);
       //currPostType = postType;
   };


const toggleStateBillCommentVote = async (commentId) => {
       try {
           // hit backend endpoint that toggles a vote
           const res = await axios.post(`/calBillComments/${commentId}/upvote`);


           /*setComment(prev => ({
               ...prev,
               upvotes: res.data.upvotes,
               voted: res.data.voted
           }));*/
           setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "stateBill") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );
       } catch(err) {
           console.error("Vote error", err);
       }
   };


const toggleCalPropCommentVote = async (commentId) => {
      try {
          // hit backend endpoint that toggles a vote
          const res = await axios.post(`/calPropComments/${commentId}/upvote`);


          /*setComment(prev => ({
              ...prev,
              upvotes: res.data.upvotes,
              voted: res.data.voted
          }));*/
          setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "calProp") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );
      } catch(err) {
          console.error("Vote error", err);
      }
  };


const toggleBillCommentVote = async (commentId) => {
       try {
            // hit backend endpoint that toggles a vote
            const res = await axios.post(`/billComments/${commentId}/upvote`);

            setGovComments(prev =>
              prev.map(post => {
                if (post.type !== "bill") return post;

                return {
                  ...post,
                  comments: post.comments.map(c =>
                    c._id === commentId
                      ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                      : c
                  )
                };
              })
            );

       } catch(err) {
           console.error("Vote error", err);
       }
   };
   /*
   const toggleBillCommentVote = async (commentId) => {
       try {
           const res = await axios.post(`/billComments/${commentId}/upvote`);
           const commentRes = await axios.get(`/bill/${id}/comments`);
           setGovComments(commentRes.data);
       } catch(err) {
           console.error("Vote error", err);
       }
   };*/
 
   const toggleScotusCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/scotusCaseComments/${commentId}/upvote`);


               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           /*setComment((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );*/
              setGovComments(prev =>
                prev.map(post => {
                  if (post.type !== "scotus") return post;

                  return {
                    ...post,
                    comments: post.comments.map(c =>
                      c._id === commentId
                        ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                        : c
                    )
                  };
                })
              );


       } catch(err) {
           console.error("Vote error", err);
       }
   };

   function updateReplyRecursive(replies, replyId, newData) {
      return (replies || []).map((r) => {
        if (r._id === replyId) {
          return { ...r, ...newData }; // update this reply
        }
        return {
          ...r,
          replies: updateReplyRecursive(r.replies, replyId, newData), // recurse deeper
        };
      });
    }

    const toggleBillReplyVote = async (replyId, id) => {
      try {
        const res = await axios.post(`/bill/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "bill" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );

      } catch (err) {
        console.error("Reply vote error", err);
      }
    };

    const toggleScotusReplyVote = async (replyId, id) => {
      try {
        const res = await axios.post(`/scotusCase/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
          }))
        );*/

        setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "scotus" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );
      } catch (err) {
        console.error("Reply vote error", err);
      }
    };

    const toggleStateBillReplyVote = async (replyId, id) => {
       try {
        const res = await axios.post(`/calBill/${id}/commentReplies/${replyId}/upvote`);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments((prevComments) =>
            prevComments.map((c) => ({
              ...c,
              replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
            }))
          );
          */
         setGovComments((prev) =>
          prev.map((post) => {
            if (post.type !== "stateBill" || post._id !== id) return post;

            return {
              ...post,
              comments: post.comments.map((c) => {
                if (c._id === replyId) {
                  // top-level reply is actually a comment
                  return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                }
                return {
                  ...c,
                  replies: updateReplyRecursive(c.replies, replyId, {
                    upvotes: replyUpvotes,
                    voted: replyVoted,
                  }),
                };
              }),
            };
          })
        );
        } catch (err) {
          console.error("Reply vote error", err);
        }
      };

      const toggleCalPropReplyVote = async (replyId, id) => {
          try {
          const res = await axios.post(`/calProp/${id}/commentReplies/${replyId}/upvote`);
          const { replyUpvotes, replyVoted } = res.data;

          /*setGovComments((prevComments) =>
            prevComments.map((c) => ({
              ...c,
              replies: updateReplyRecursive(c.replies, replyId, { upvotes, voted }),
            }))
          );*/
          setGovComments((prev) =>
            prev.map((post) => {
              if (post.type !== "calProp" || post._id !== id) return post;

              return {
                ...post,
                comments: post.comments.map((c) => {
                  if (c._id === replyId) {
                    // top-level reply is actually a comment
                    return { ...c, upvotes: replyUpvotes, voted: replyVoted };
                  }
                  return {
                    ...c,
                    replies: updateReplyRecursive(c.replies, replyId, {
                      upvotes: replyUpvotes,
                      voted: replyVoted,
                    }),
                  };
                }),
              };
            })
          );
          } catch (err) {
          console.error("Reply vote error", err);
          }
      };

const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    function updateCommentTree(comments, commentId, newData) {
      return comments.map(comment => {
        if (comment._id === commentId) {
          return { ...comment, ...newData };
        }

        if (comment.replies?.length) {
          return {
            ...comment,
            replies: updateCommentTree(comment.replies, commentId, newData)
          };
        }

        return comment;
      });
    }

    const toggleGovVote = async ({ postType, postId, commentId }) => {
      try {
        let endpoint = "";

        if (postType === "bill") {
          endpoint = `/bill/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType === "scotus") {
          endpoint = `/scotusCase/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType === "stateBill") {
          endpoint = `/calBill/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType == "houseOfRepElectionPoll") {
          endpoint = `/elections/USHouseOfRep/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType == "senateElectionPoll") {
          endpoint = `/elections/USSenate/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType == "gubernatorialElectionPoll") {
          endpoint = `/elections/GubernatorialElections/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType == "stateLegislatureElectionPoll") {
          endpoint = `/elections/StateLegislature/${postId}/commentReplies/${commentId}/upvote`;
        } else if (postType == "statewideOfficesElectionPoll") {
          endpoint = `/elections/StatewideOffices/${postId}/commentReplies/${commentId}/upvote`;
        }

        const res = await axios.post(endpoint);
        const { replyUpvotes, replyVoted } = res.data;

        /*setGovComments(prev =>
          prev.map(post => {
            if (post._id !== postId || post.type !== postType) {
              return post;
            }

            return {
              ...post,
              comments: updateCommentTree(post.comments, commentId, {
                upvoteCount: replyUpvotes,
                voted: replyVoted
              })
            };
          })
        );*/
        setGovComments(prev =>
          prev.map(post => {
            if (post._id !== postId || post.type !== postType) {
              return post;
            }

            // POPULAR MODE: update topComment
            if (mode === "popular" && post.topComment) {
              if (String(post.topComment._id) === String(commentId)) {
                return {
                  ...post,
                  topComment: {
                    ...post.topComment,
                    upvoteCount: replyUpvotes,
                    voted: replyVoted
                  }
                };
              }
              return post;
            }

            // FOLLOWING MODE: update comments tree
            return {
              ...post,
              comments: updateCommentTree(post.comments, commentId, {
                upvoteCount: replyUpvotes,
                voted: replyVoted
              })
            };
          })
        );

      } catch (err) {
        console.error("Vote error", err);
      }
    };

    /*const handleUndoVote = async (postId, post) => {
      try {
        let endpoint = "";
        console.log(postId);

        if (post.type === "scotus") {
          endpoint = `/scotusCase/${postId}/undoVote`;
        } else if (post.type === "bill") {
          endpoint = `/bill/${postId}/undoVote`;
        } else if (post.type === "stateBill") {
          endpoint = `/calBill/${postId}/undoVote`;
        }

        const res = await axios.post(endpoint);
        const { deletedCommentId } = res.data;

        console.log("Deleted ID:", deletedCommentId);

        setGovComments(prev => {
          const targetPost = prev.find(p => p._id === postId);

          console.log(
            "Comments currently in state:",
            targetPost?.comments?.map(c => c._id)
          );

          return prev;
        });

        // Update local post state (for feed posts)
        setGovComments(prev =>
          prev.map(p =>
            p._id === postId
              ? {
                  ...p,
                  voted: false,
                  voteType: null,
                  comments: (p.comments || []).filter(
                    c => String(c._id) !== String(deletedCommentId)
                  )
                }
              : p
          )
        );
      } catch (err) {
        console.error("Error undoing vote:", err);
      }
    };*/
    const handleUndoVote = async (postId, post) => {
      try {
        let endpoint = "";

        if (post.type === "scotus") {
          endpoint = `/scotusCase/${postId}/undoVote`;
        } else if (post.type === "bill") {
          endpoint = `/bill/${postId}/undoVote`;
        } else if (post.type === "stateBill") {
          endpoint = `/calBill/${postId}/undoVote`;
        }

        const res = await axios.post(endpoint);

        if (post.type == "scotus") {
          /*
          const {
            upvotes,
            scotusCaseVoted,
            deletedCommentId
          } = res.data;

          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;

              const votedPetitioner = p.petitionerPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              const votedRespondent = p.respondentPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              return {
                ...p,

                // reset voted flags
                voted: false,
                voteType: null,
                scotusCaseVoted,

                // update counts depending on side voted
                ...(votedPetitioner ? { petitionerCount: upvotes } : {}),
                ...(votedRespondent ? { respondentCount: upvotes } : {}),

                // remove user from global voters
                scotusCaseVoters: (p.scotusCaseVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),

                // remove from vote arrays
                petitionerPowerVotes: (p.petitionerPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                respondentPowerVotes: (p.respondentPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                // remove deleted rationale comment
                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                )
              };
            })
          );*/
          const { upvotes, deletedCommentId } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;
              return {
                ...p,
                // Use votedSide stored on local state to know which count to decrement
                ...(p.votedSide === 'petitioner' ? { petitionerCount: upvotes } : {}),
                ...(p.votedSide === 'respondent' ? { respondentCount: upvotes } : {}),
                votedScotusCase: false,
                votedSide:       null,
                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                ),
              };
            })
          );
      } else if (post.type === "bill") {
        const { upvotes, deletedCommentId } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;
              return {
                ...p,
                // Use votedSide stored on local state to know which count to decrement
                ...(p.votedSide === 'no pass' ? { noPassCount: upvotes } : {}),
                ...(p.votedSide === 'pass' ? { passCount: upvotes } : {}),
                votedBill: false,
                votedSide:       null,
                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                ),
              };
            })
          );
        /*
          const {
            upvotes,
            billVoted,
            deletedCommentId
          } = res.data;

          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;

              const votedNoPass = p.noPassPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              const votedPass = p.passPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              return {
                ...p,

                billVoted,

                ...(votedNoPass ? { noPassCount: upvotes } : {}),
                ...(votedPass ? { passCount: upvotes } : {}),

                billVoters: (p.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),

                noPassPowerVotes: (p.noPassPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                passPowerVotes: (p.passPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                )
              };
            })
          );*/
        } else if (post.type == "stateBill") {
          const { upvotes, deletedCommentId } = res.data;
          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;
              return {
                ...p,
                // Use votedSide stored on local state to know which count to decrement
                ...(p.votedSide === 'no pass' ? { noPassCount: upvotes } : {}),
                ...(p.votedSide === 'pass' ? { passCount: upvotes } : {}),
                votedStateBill: false,
                votedSide:       null,
                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                ),
              };
            })
          );
          /*const {
            upvotes,
            billVoted,
            deletedCommentId
          } = res.data;

          setGovComments(prev =>
            prev.map(p => {
              if (p._id !== postId) return p;

              const votedNoPass = p.noPassPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              const votedPass = p.passPowerVotes?.some(v =>
                isSameUser(v.user, loggedInUser._id)
              );

              return {
                ...p,

                billVoted,

                ...(votedNoPass ? { noPassCount: upvotes } : {}),
                ...(votedPass ? { passCount: upvotes } : {}),

                billVoters: (p.billVoters || []).filter(
                  v => !isSameUser(v, loggedInUser._id)
                ),

                noPassPowerVotes: (p.noPassPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                passPowerVotes: (p.passPowerVotes || []).filter(
                  v => !isSameUser(v.user, loggedInUser._id)
                ),

                comments: (p.comments || []).filter(
                  c => String(c._id) !== String(deletedCommentId)
                )
              };
            })
          );*/
        }
/*else if (post.type == "bill") {
          const { 
            upvotes, 
            billVoted, 
            deletedCommentId 
          } = res.data;

          if (
              bill.noPassPowerVotes?.some(
                  vote => isSameUser(vote.user, loggedInUser._id)
              )
              ) {
                  setGovComments(prev => {
                      if (!prev || prev._id !== billId) return prev;
                          return {
                              ...prev,

                              // keep working count logic
                              noPassCount: upvotes,
                              billVoted,

                              // remove user from arrays so button updates
                              billVoters: (prev.billVoters || []).filter(
                                  v => !isSameUser(v, loggedInUser._id)
                              ),
                              noPassPowerVotes: (prev.noPassPowerVotes || []).filter(
                                  v => !isSameUser(v.user, loggedInUser._id)
                              ),
                              // remove deleted rationale comment
                              comments: (prev.comments || []).filter(
                                c => String(c._id) !== String(deletedCommentId)
                              )
                          }
                      }
                  );
              } else if (
                  bill.passPowerVotes?.some(
                      vote => isSameUser(vote.user, loggedInUser._id)
                  )
              ) {
                  setGovComments(prev => {
                      if (!prev || prev._id !== billId) return prev;
                          return {
                              ...prev,

                              // keep working count logic
                              passCount: upvotes,
                              billVoted,

                              // remove user from arrays so button updates
                              billVoters: (prev.billVoters || []).filter(
                                  v => !isSameUser(v, loggedInUser._id)
                              ),
                              passPowerVotes: (prev.passPowerVotes || []).filter(
                                  v => !isSameUser(v.user, loggedInUser._id)
                              ),
                              // remove deleted rationale comment
                              comments: (prev.comments || []).filter(
                                c => String(c._id) !== String(deletedCommentId)
                              )
                          }
                      }
                  );
              }
      }*/
      } catch (err) {
        console.error("Error undoing vote:", err);
      }
    };

    /*const openVoters = (e, post, voteCategory) => {
      e.stopPropagation();

      let voters = [];
      let title = "";

      if (post.type === "scotus") {
        if (voteCategory === "petitioner") {
          voters = post.petitionerPowerVotes || [];
          title = "For Petitioner Votes";
        } else if (voteCategory === "respondent") {
          voters = post.respondentPowerVotes || [];
          title = "For Respondent Votes";
        }
      }

      if (post.type === "bill" || post.type === "stateBill") {
        if (voteCategory === "pass") {
          voters = post.passPowerVotes || [];
          title = "Pass Votes";
        } else if (voteCategory === "noPass") {
          voters = post.noPassPowerVotes || [];
          title = "No Pass Votes";
        }
      }

      setDialogTitle(title);
      setActiveVoters(voters);
      setOpenVotersDialog(true);
    };*/

    const isSameUser = (voteUser, loggedInUserId) => {
      if (!voteUser) return false;
      return typeof voteUser === "string"
        ? voteUser === loggedInUserId
        : voteUser._id === loggedInUserId;
    };

    /*const getUserVoteType = (post) => {
      if (!loggedInUser) return null;

      if (post.type === "scotus") {
        if (post.petitionerPowerVotes?.some(v => isSameUser(v.user, loggedInUser._id))) {
          return "For Petitioner";
        }
        if (post.respondentPowerVotes?.some(v => isSameUser(v.user, loggedInUser._id))) {
          return "For Respondent";
        }
      }

      if (post.type === "bill" || post.type === "stateBill") {
        if (post.passPowerVotes?.some(v => isSameUser(v.user, loggedInUser._id))) {
          return "Pass";
        }
        if (post.noPassPowerVotes?.some(v => isSameUser(v.user, loggedInUser._id))) {
          return "No Pass";
        }
      }

      return null;
    };*/
    const getUserVoteType = (post) => {
       if (!loggedInUser) return null;

       if (post.type === "bill") {
          /*const passVoted = (post.passVotes || []).some(v => isSameUser(v.user, loggedInUser._id));
          const noPassVoted = (post.noPassVotes || []).some(v => isSameUser(v.user, loggedInUser._id));
          if (passVoted) return "Pass";
          if (noPassVoted) return "No Pass";
          return null;*/
          if (!post.votedBill) return null;
          return post.votedSide === "no pass" ? "No Pass" : "Pass";
       } else if (post.type == "stateBill") {
          if (!post.votedStateBill) return null;
          return post.votedSide === "no pass" ? "No Pass" : "Pass";
       }
       if (post.type === "scotus") {
          // Read the field set by the backend — no array scanning
          if (!post.votedScotusCase) return null;
          return post.votedSide === "petitioner" ? "For Petitioner" : "For Respondent";
        }
        return null;
    };

const renderComments = (comments, parentText = null, parentUsername = null, parentId, postId, postType) => {
 return comments.flatMap((comment, i) => {
   const thisComment = (
     <Box
       key={comment._id || i}
       onClick={(e) => {
          e.stopPropagation(); 
          if (postType== "bill") {
            history.push(`/bill/${postId}/comments/${comment._id}`)
          } else if (postType == "scotus") {
            history.push(`/scotusCase/${postId}/comments/${comment._id}`)
          } else if (postType == "stateBill") {
            history.push(`/calBill/${postId}/comments/${comment._id}`)
          } else if (postType == "houseOfRepElectionPoll") {
            history.push(`/Government/Elections/USHouseOfRepElections/${postId}/comments/${comment._id}`)
          } else if (postType == "senateElectionPoll") {
            history.push(`/Government/Elections/USSenateElections/${postId}/comments/${comment._id}`)
          } else if (postType == "gubernatorialElectionPoll") {
            history.push(`/Government/Elections/GubernatorialElections/${postId}/comments/${comment._id}`)
          } else if (postType == "stateLegislatureElectionPoll") {
            history.push(`/Government/Elections/StateLegislatureElections/${postId}/comments/${comment._id}`)
          } else if (postType == "statewideOfficesElectionPoll") {
            history.push(`/Government/Elections/StatewideOfficesElections/${postId}/comments/${comment._id}`)
          }
        }
       }
       mt={2}
       p={2}
       border="1px solid #eee"
       borderRadius="6px"
       sx={{
          "&:hover": {
            //backgroundColor: "#eaeaea", // inner hover overrides
            //backgroundColor: "#f0f4f9", // inner hover overrides
            backgroundColor: "#e6edf7", // inner hover overrides
          },
        }}
     >
       {/* If this is a reply, show the parent text above */}
       {parentText && (
         <Box 
          onClick={(e) => {
              e.stopPropagation(); 
              if (postType== "bill") {
                history.push(`/bill/${postId}/comments/${parentId}`)
              } else if (postType == "scotus") {
                history.push(`/scotusCase/${postId}/comments/${parentId}`)
              } else if (postType == "stateBill") {
                history.push(`/calBill/${postId}/comments/${parentId}`)
              } else if (postType == "houseOfRepElectionPoll") {
                history.push(`/Government/Elections/USHouseOfRepElections/${postId}/comments/${parentId}`)
              } else if (postType == "senateElectionPoll") {
                history.push(`/Government/Elections/USSenateElections/${postId}/comments/${parentId}`)
              } else if (postType == "gubernatorialElectionPoll") {
                history.push(`/Government/Elections/GubernatorialElections/${postId}/comments/${parentId}`)
              } else if (postType == "stateLegislatureElectionPoll") {
                history.push(`/Government/Elections/StateLegislatureElections/${postId}/comments/${parentId}`)
              } else if (postType == "statewideOfficesElectionPoll") {
                history.push(`/Government/Elections/StatewideOfficesElections/${postId}/comments/${parentId}`)
              }
            }
          }
          mb={1} 
          p={1} 
          borderLeft="3px solid #aaa" 
          pl={2}
          sx={{
          "&:hover": {
            backgroundColor: "#d9e4f0", // inner hover overrides
          },
        }}
        >
           <Typography variant="caption" color="textSecondary">
             In reply to @{parentUsername}: {parentText}
           </Typography>
         </Box>
       )}


       {/* Main comment/reply */}
       <Box display="flex" alignItems="flex-start" gap={1}>
       	<Avatar
             		src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                    alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                    onClick={(e) => visitProfile(e, comment.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
       	/>
       	<Box>
              	<Typography variant="subtitle1" fontWeight="bold"
                onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                >
                    	{comment.author?.first_name && comment.author?.last_name
                                   ? `${comment.author.first_name} ${comment.author.last_name}`
                                   : 'Unknown Name'}
                     </Typography>
                     <Typography variant="body2" color="text.secondary"
                     onClick={(e) => visitProfile(e, comment.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                     >
                     	@{comment.author?.username || 'unknown'}
                     </Typography>


                     {/* Post content */}
                     <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                     	{comment.text}
                     </Typography>


                     {/* Date */}
                     <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                 {`${new Date(comment.created_at).toLocaleString()}, ${comment.replyCount} ${comment.replyCount === 1 ? 'reply' : 'replies'}`}
                     </Typography>


              </Box>
       </Box>


       {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
          <Button
            size="small"
            variant={comment.voted ? "contained" : "outlined"}
            onClick={(e) => {
              e.stopPropagation();
              toggleGovVote({
                postType,
                postId,
                commentId: comment._id
              });
            }}
          >
              ▲ {comment.voted ? "Unvote" : "Upvote"}
          </Button>
               <Typography variant="body2">{comment.upvoteCount} upvotes</Typography>
        </Box>*/}
        <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleGovVote({
                                        postType,
                                        postId,
                                        commentId: comment._id
                                      });
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleGovVote({
                                        postType,
                                        postId,
                                        commentId: comment._id
                                      });
                                    }}
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.upvoteCount} Power Votes</Typography>
                    </Box>
     </Box>
   );


   // Recursively render replies but flatten them into the same level
   const childReplies =
     comment.replies?.length > 0
       ? renderComments(comment.replies, comment.text, comment.author.username, comment._id, postId, postType)
       : [];


   return [thisComment, ...childReplies];
 });
};

//const totalVotes = govComments?.options.reduce((sum, o) => sum + o.votes, 0);
/*
   const sortedResults = [...govComments?.options]
       .sort((a, b) => b.votes - a.votes)
       .map(opt => ({
           ...opt,
           percentage: totalVotes
               ? Math.round((opt.votes / totalVotes) * 100)
               : 0,
   }));
*/
   //const votedOption = govComments?.options.find(o => o.id === govComments.userVote);
   //const votedOptionLabel = votedOption?.label;

   /*const undoElectionVote = async (post) => {
       try {
           if (post.type == "houseOfRepElectionPoll") {
            	await axios.post(`/elections/USHouseOfRep/${post._id}/undoVote`);
          } else if (post.type == "senateElectionPoll") {
            await axios.post(`/elections/USSenate/${post._id}/undoVote`);
          } else if (post.type == "gubernatorialElectionPoll") {
            await axios.post(`/elections/GubernatorialElections/${post._id}/undoVote`);
          } else if (post.type == "stateLegislatureElectionPoll") {
              await axios.post(`/elections/StateLegislature/${post._id}/undoVote`);
    	    } else if (post.type == "statewideOfficesElectionPoll") {
             await axios.post(`/elections/StatewideOffices/${post._id}/undoVote`);
           }
       } catch (err) {
           console.error("Undo vote failed", err);
       }
    };*/
    const undoElectionVote = async (post) => {
      try {
        let endpoint = "";

        if (post.type === "houseOfRepElectionPoll") {
          endpoint = `/elections/USHouseOfRep/${post._id}/undoVote`;
        } else if (post.type === "senateElectionPoll") {
          endpoint = `/elections/USSenate/${post._id}/undoVote`;
        } else if (post.type === "gubernatorialElectionPoll") {
          endpoint = `/elections/GubernatorialElections/${post._id}/undoVote`;
        } else if (post.type === "stateLegislatureElectionPoll") {
          endpoint = `/elections/StateLegislature/${post._id}/undoVote`;
        } else if (post.type === "statewideOfficesElectionPoll") {
          endpoint = `/elections/StatewideOffices/${post._id}/undoVote`;
        } else {
          console.warn("Unknown post type for undo vote:", post.type);
          return;
        }

        const res = await axios.post(endpoint);

        const { optionId, votes } = res.data;

        // Update ONLY the affected poll in state
        setGovComments(prev =>
          prev.map(p => {
            if (p._id !== post._id) return p;

            return {
              ...p,

              // user no longer has a vote
              userVote: null,

              // update the specific option count
              options: (p.options || []).map(opt =>
                opt.id === optionId
                  ? { ...opt, votes }
                  : opt
              )
            };
          })
        );

      } catch (err) {
        console.error("Undo vote failed", err);
      }
    };

   const showVotersForOption = (optionId, post) => {
      if (!post?.votes) return;

      const voters = post.votes.filter(
        v => v.optionId === optionId
      );

      setSelectedOptionVoters(voters);
      setVotersDialogOpen(true);
    };

   const VoteDialog = ({ open, onClose, options, pollId, onVoted, post }) => {
       const [selected, setSelected] = useState("");
       const [comment, setComment] = useState("");

       const handleSubmit = async () => {
           if (!selected || !comment.trim()) return;
           
           if (post.type == "houseOfRepElectionPoll") {
              const commentRes = await axios.post(
                  `/elections/USHouseOfRep/${pollId}/comment`,
                  { text: comment }
              );

              const commentId = commentRes.data._id;

              await axios.post(
                  `/elections/USHouseOfRep/${pollId}/vote`,
                  { optionId: selected, commentId }
              );

              const pollRes = await axios.get(`/elections/USHouseOfRep/singlePoll/${pollId}`);

              onVoted(pollRes.data);
           } else if (post.type == "senateElectionPoll") {
              const commentRes = await axios.post(
                    `/elections/USSenate/${pollId}/comment`,
                    { text: comment }
                );

                const commentId = commentRes.data._id;

                await axios.post(
                    `/elections/USSenate/${pollId}/vote`,
                    { optionId: selected, commentId }
                );

                const pollRes = await axios.get(`/elections/USSenate/singlePoll/${pollId}`);

                onVoted(pollRes.data);
      	    } else if (post.type == "gubernatorialElectionPoll") {
                const commentRes = await axios.post(
                    `/elections/GubernatorialElections/${pollId}/comment`,
                    { text: comment }
                );

                const commentId = commentRes.data._id;

                await axios.post(
                    `/elections/${pollId}/vote`,
                    { optionId: selected, commentId }
                );

                const pollRes = await axios.get(`/elections/singlePoll/${pollId}`);

                onVoted(pollRes.data);
           } else if (post.type == "stateLegislatureElectionPoll") {
                const commentRes = await axios.post(
                    `/elections/StateLegislature/${pollId}/comment`,
                    { text: comment }
                );

                const commentId = commentRes.data._id;

                await axios.post(
                    `/elections/StateLegislature/${pollId}/vote`,
                    { optionId: selected, commentId }
                );

                const pollRes = await axios.get(`/elections/StateLegislature/singlePoll/${pollId}`);

                onVoted(pollRes.data);
           } else if (post.type == "statewideOfficesElectionPoll") {
                const commentRes = await axios.post(
                    `/elections/StatewideOffices/${pollId}/comment`,
                    { text: comment }
                );

                const commentId = commentRes.data._id;

                await axios.post(
                    `/elections/StatewideOffices/${pollId}/vote`,
                    { optionId: selected, commentId }
                );

                const pollRes = await axios.get(`/elections/StatewideOffices/singlePoll/${pollId}`);

                onVoted(pollRes.data);
           }

 	         //const res = await axios.get('/api/gov-comments/followed')
           //setGovComments(res.data);
           /*if (mode === "popular") {
              const getCommentRes = await axios.get('/api/topGov');
              setGovComments(getCommentRes.data);
           } else {
              const getCommentRes = await axios.get('/api/gov-comments/followed');
              setGovComments(getCommentRes.data);
           }*/
   
           onClose();
       };

       return (
           <Dialog
               open={open}
               onClose={onClose}
               fullWidth
               PaperProps={{
                   sx: {
                       backgroundColor: "#FFFDF8",
                       borderRadius: 3,
                   },
               }}
           >
               <DialogTitle>Cast Your Power Vote</DialogTitle>

               <DialogContent>
                   <RadioGroup
                       value={selected}
                       onChange={(e) => setSelected(e.target.value)}
                   >
                       {options?.map(opt => (
                           <FormControlLabel
                               key={opt.id}
                               value={opt.id}
                               control={<Radio />}
                               label={opt.label}
                           />
                       ))}
                   </RadioGroup>

                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
               </DialogContent>

               <DialogActions>
                   <Button onClick={onClose}>Cancel</Button>
                   <Button
                       variant="outlined"
                       disabled={!comment || !selected}
                       onClick={handleSubmit}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>
       );
   };

   const ResultRow = ({ item, onVotesClick }) => (
       <Box
           display="flex"
           justifyContent="space-between"
           alignItems="center"
           py={1}
           borderBottom="1px solid #eee"
       >
           <Box>
               <Typography fontWeight={500}>{item.label}</Typography>
               {/* CLICKABLE VOTE COUNT */}
               <Typography
                   variant="caption"
                   color="primary"
                   //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                   //onClick={() => onVotesClick(item.id)}
                   onClick={(e) => {
                        e.stopPropagation();
                        onVotesClick(item.id);
                    }}
               >
                   {item.votes} Power Votes
               </Typography>
           </Box>

           <Typography fontWeight={500}>
               {item.percentage}%
           </Typography>
       </Box>
   );

   /*const handleSubmitNewPost = async () => {
       if (!newPost.trim()) return;

       try {
           const res = await axios.post('/user/govPost', { content: newPost });

           // Add new post to list
           const postRes = await axios.get('/api/gov-comments/followed')
           setGovComments(postRes.data);

           // Clear input
           setNewPost('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };*/
   const handleSubmitNewPost = async () => {
      if (!newPost.trim()) return;
      try {
        const res = await axios.post('/user/govPost', { content: newPost });

        // Prepend the new post directly — no refetch needed
        // The backend already returns the fully populated post object
        setGovComments(prev => {
          // prev is always an array — guard just in case
          const current = Array.isArray(prev) ? prev : [];
          return [{ ...res.data, type: "govPost" }, ...current];
        });

        setNewPost('');
      } catch (err) {
        console.error("Error submitting post", err);
      }
    };

   const toggleVote = async (postId) => {
        try {
           const res = await axios.post(`/govPost/${postId}/upvote`);
           const { upvotes, voted } = res.data;

           //const postRes = await axios.get('/api/gov-comments/followed')
           //setGovComments(postRes.data);
           /*if (mode === "popular") {
              const getCommentRes = await axios.get('/api/topGov');
              setGovComments(getCommentRes.data);
           } else {
              const getCommentRes = await axios.get('/api/gov-comments/followed');
              setGovComments(getCommentRes.data);
           }*/
          setGovComments(prev =>
                Array.isArray(prev)
                  ? prev.map(post =>
                      post._id?.toString() === postId?.toString()
                        ? { ...post, upvotes, upvoteCount: upvotes, voted }
                        : post
                    )
                  : prev
              );

        } catch(err) {
            console.error("Vote error", err);
        }
    };

    const renderTopComment = (post) => {
      if (mode !== "popular") {
        // Following mode: full comment tree as normal
        return renderComments(post.comments, null, null, null, post._id?.toString(), post.type);
      }
      // Popular mode: only render the single ranked comment
      if (post.sourceType === "govComment" && post.topComment) {
        /*return renderComments(
          [post.topComment],
          null,
          null,
          null,
          post._id?.toString(),
          post.type
        );*/
        return renderComments(
          [post.topComment],
          post.topComment.parentText,
          post.topComment.parentUsername,
          post.topComment.parentComment,
          post._id?.toString(),
          post.type
        )
      } 
      return null;
    };

    const navItems = [
      { label: "Popular Opinion", path: "/Government/popular" },
      { label: "Following", path: "/Government/following" },
      { label: "Supreme Court", path: "/Government/SupremeCourt" },
      { label: "Congressional Bills", path: "/Government/CongressionalBills" },
      { label: "State Legislature Bills", path: "/Government/StateBills" },
      { label: "Elections", path: "/Government/Elections/GubernatorialElections" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };

 return (
   <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           {/*<Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/government/popular')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/government/following')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
                  
              </Box>*/}
              {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>

              {mode !== "popular" && (
              <Box
                  p={2} // padding inside box
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  sx={{
                      position: "relative",
                      maxWidth: 900, // limit width
                      mx: "auto", // center horizontally
                      my: 2, // vertical spacing between each post
                  }}
              >
              <TextField
                  fullWidth
                  multiline
                  rows={2}
                  placeholder="Pause. Muse — and write..."
                  //value={newComment}
                  //onChange={e => setNewComment(e.target.value)}
                  value={newPost}
                  onChange={(e) => setNewPost(e.target.value)} 
              />
              <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitNewPost}>
                  Submit Post
              </Button>
              </Box>
              )}
              
              {govComments.map((post, i) => {
                const isLast = mode !== "popular" && i === govComments.length - 1;
                const totalVotes = post.options?.reduce((sum, o) => sum + o.votes, 0);
                const sortedResults = [...(post.options || [])]
                    .sort((a, b) => b.votes - a.votes)
                    .map(opt => ({
                        ...opt,
                        percentage: totalVotes
                            ? Math.round((opt.votes / totalVotes) * 100)
                            : 0,
                }));
                const votedOption = post.options?.find(o => o.id === post.userVote);
                const votedOptionLabel = votedOption?.label;

                let leftCount = 0;
                let rightCount = 0;
                let votePercentage = 0;
                let offset = 0;

                if (post.type == "bill") {
                    leftCount = post.noPassCount || 0;
                    rightCount = post.passCount || 0;
                } else if (post.type == "scotus") {
                    leftCount = post.petitionerCount || 0;
                    rightCount = post.respondentCount || 0;
                } else if (post.type == "calProp") {
                    leftCount = post.noCount || 0;
                    rightCount = post.yesCount || 0; 
                } else if (post.type == "stateBill") {
                    leftCount = post.noPassCount || 0;
                    rightCount = post.passCount || 0; 
                }

                if (rightCount > leftCount) {
                    votePercentage = rightCount/(rightCount+leftCount);
                } else if (leftCount > rightCount) {
                    votePercentage = leftCount/(rightCount+leftCount);
                }

                if (rightCount > leftCount) {
                    offset = votePercentage * 50; // move right
                } else if (leftCount > rightCount) {
                    offset = -votePercentage * 50; // move left
                }

                let tickColor = "blue";
                let postCommentsPage = ``;
                let leftVote = "";
                let rightVote = "";
                let docLink = ``;

                if (post.type == "bill") {
                    if (offset > 0) {
                        tickColor = "#00c853"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/bill/${post._id}/comments`;
                    leftVote = "No Pass Votes";
                    rightVote = "Pass Votes";
                } else if (post.type == "scotus") {
                    if (offset > 0) {
                        tickColor = "red"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/scotusCase/${post._id}/comments`;
                    leftVote = "For Petitioner";
                    rightVote = "For Respondent";
                } else if (post.type == "calProp") {
                    if (offset > 0) {
                        tickColor = "#00c853"; // right side
                    } else if (offset < 0) {
                        tickColor = "red"; // left side
                    }
                    postCommentsPage = `/calProp/${post._id}/comments`;
                    leftVote = "No";
                    rightVote = "Yes";
                } else if (post.type == "stateBill") {
                    if (offset > 0) {
                      tickColor = "red"; // right side
                    } else if (offset < 0) {
                      tickColor = "red"; // left side
                    }
                    postCommentsPage = `/calBill/${post._id}/comments`;
                    leftVote = "No Pass Votes";
                    rightVote = "Pass Votes";
                    docLink = `/api/bill/pdf/${post.doc_id}`;
                }

                const getPdfLink = (post) => {
                  switch (post.type) {
                    case "bill":
                      return { href: post.pdf, label: "View Bill" };
                    case "scotus":
                      return { href: post.pdfUrl, label: "View PDF" };
                    case "calProp":
                      return { href: `/api/calProp/pdf/${post.doc_id}`, label: "View Proposition" };
                    case "stateBill":
                      return { href: `/api/bill/pdf/${post.doc_id}`, label: "View PDF" };
                    default:
                      return null; // no link if type doesn’t match
                  }
                };
                const pdfLink = getPdfLink(post);

                {/*const getVoteVars = (post) => {
                  switch (post.type) {
                    case "bill":
                      return {  
                        lCount: post.noPassCount,
                        rCount: post.passCount,
                        lLabel: "No Pass Votes",
                        rLabel: "Pass Votes",
                      };
                    case "scotus":
                      return {  
                        lCount: post.petitionerCount,
                        rCount: post.respondentCount,
                        lLabel: "For Petitioner Votes",
                        rLabel: "For Respondent Votes",
                      };
                    case "stateBill":
                      return {  
                        lCount: post.noPassCount,
                        rCount: post.passCount,
                        lLabel: "No Pass Votes",
                        rLabel: "Pass Votes",
                      };
                    default:
                      return null;
                  }
                };
                const voteVar = getVoteVars(post);
                */}

                const userVoteType = getUserVoteType(post);

                const isGovPost = mode === "popular" 
                  ? post.sourceType === "govPost" 
                  : post.type === "govPost";
                const isBill = !isGovPost && post.type === "bill";
                const isScotus = !isGovPost && post.type === "scotus";
                const isStateBill = !isGovPost && post.type === "stateBill";
                const isPoll =
                  post.type === "houseOfRepElectionPoll" ||
                  post.type === "senateElectionPoll" ||
                  post.type === "gubernatorialElectionPoll" ||
                  post.type === "stateLegislatureElectionPoll" ||
                  post.type === "statewideOfficesElectionPoll";
                return (
                  <Box
                    key={post._id?.toString() || i}  
                    ref={isLast ? lastPostRef : null}
                    onClick={(e) => {
                        e.stopPropagation(); 
                        if (post.type == "bill") {
                          history.push(`/bill/${post._id}/comments`)
                        } else if (post.type == "scotus") {
                          history.push(`/scotusCase/${post._id}/comments`)
                        } else if (post.type == "stateBill") {
                           history.push(`/calBill/${post._id}/comments`)
                        } else if (post.type == "calProp") {
                           history.push(`/calProp/${post._id}/comments`)
                        } else if (post.type == "houseOfRepElectionPoll") {
                           history.push(`/Government/Elections/USHouseOfRepElections/${post._id}/comments`)
                        } else if (post.type == "senateElectionPoll") {
                           history.push(`/Government/Elections/USSenateElections/${post._id}/comments`)
                        } else if (post.type == "gubernatorialElectionPoll") {
                          history.push(`/Government/Elections/GubernatorialElections/${post._id}/comments`)
                        } else if (post.type == "stateLegislatureElectionPoll") {
                          history.push(`/Government/Elections/StateLegislatureElections/${post._id}/comments`)
                        } else if (post.type == "statewideOfficesElectionPoll") {
                          history.push(`/Government/Elections/StatewideOfficesElections/${post._id}/comments`)
                        } else if (post.type == "govPost" || post.sourceType === "govPost") {
                          //history.push(`/govPost/${post._id}/comments`)
                          history.push(`/govPost/${post._id}/comments`, { mode });
                        }
                      }
                    }
                    p={2} // padding inside box
                    my={2} // vertical margin between posts
                    border="1px solid #ccc" // light grey border
                    borderRadius="8px" // rounded corners
                    sx={{
                        position: "relative",
                        maxWidth: 900, // limit width
                        mx: "auto", // center horizontally
                        my: 2, // vertical spacing between each post
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "#f9f9f9"
                        }
                    }}
                  >
                    {(isStateBill || isBill || isScotus) && (!isPoll && !isGovPost) && (
                      <>
                    <Typography
                      fontWeight="bold"
                       sx={{
                          wordBreak: "break-word",
                          pr: "140px",
                          mb: 1
                        }}
                    >
                      {post.type === "bill" && `${post.billNum}: ${post.title}`}
                      {post.type === "scotus" && post.title}
                      {post.type === "stateBill" && `${post.number}: ${post.title}`}
                    </Typography>

                    {/*{post.type === "calProp" && post.propDescription && (
                      <Typography
                          fontWeight="regular"
                          sx={{
                            wordBreak: "break-word",
                            pr: "140px",
                            mb: 1
                            }}
                      >
                          {post.propDescription}
                      </Typography>
                    )} 
                    {post.type === "stateBill" && post.description && (
                      <Typography
                          fontWeight="regular"
                          sx={{
                            wordBreak: "break-word",
                            pr: "140px",
                            mb: 1
                            }}
                      >
                          {post.description}
                      </Typography>
                    )}*/}
                    {post.type === "bill" && (
                      <>
                        <Typography variant="body2" component="div">
                          <Box component="span" fontWeight="bold">
                            Summary:
                          </Box>

                          <Box
                            component="div"
                            sx={{ mt: 0.5 }}
                            dangerouslySetInnerHTML={{ __html: post.summary }}
                          />
                        </Typography>

                        <Typography variant="body2">
                          <Box component="span" fontWeight="bold">
                            Latest Action:
                          </Box>{" "}
                          {post.latestAction
                            ? `${post.latestAction.date} — ${post.latestAction.text}`
                            : "No recent action"}
                        </Typography>

                        {post.billText ? (
                          <Link
                            href={post.billText}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ display: "block" }}
                          >
                            Bill Web Text
                          </Link>
                        ) : (
                          <Typography variant="caption" sx={{ display: "block" }}>
                            Bill text not available
                          </Typography>
                        )}

                        {post.pdf ? (
                          <Link
                            href={post.pdf}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            sx={{ display: "block" }}
                          >
                            Bill PDF
                          </Link>
                        ) : (
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            PDF not available
                          </Typography>
                        )}
                      </>
                    )}

                    {post.type === "stateBill" && (
                      <>
                        <Typography variant="body2" component="div">
                          <Box component="span" fontWeight="bold">
                            Summary:
                          </Box>

                          <Box component="div" sx={{ mt: 0.5 }}>
                            {post?.description}
                          </Box>
                        </Typography>

                        <Typography variant="body2">
                          <Box component="span" fontWeight="bold">
                            Latest Action:
                          </Box>{" "}
                          {post?.last_action || post?.last_action_date ? (
                            <>
                              {post?.last_action_date
                                ? new Date(post?.last_action_date).toLocaleDateString()
                                : "—"}{" "}
                              — {post?.last_action || "Action recorded"}
                            </>
                          ) : (
                            "No recent action"
                          )}
                        </Typography>

                        <Link
                          href={`/api/bill/pdf/${post?.doc_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          View Bill
                        </Link>
                      </>
                    )}
       
                    {/*<Box
                      display="flex"
                      justifyContent="center"
                      sx={{
                          mb: 2,
                          //my: 1
                      }}
                    >
                      <Button
                          variant="outlined"
                          size="small"
                          onClick={(e) => {
                              e.stopPropagation(); 
                              handleOpenDialog(post._id, post.type)}
                          }
                          //sx={{ ml: 2.3 }}
                          //sx={{
                          //  ml: post.type === "calProp" || post.type === "scotus" ? -2.3 : 2.3, 
                          //}}
                          sx={{
                            ml: post.type === "calProp"
                              ? -1
                              : post.type === "scotus"
                              ? -2.3
                              : 2.3
                          }}
                      >
                          Power Vote
                      </Button>
                    </Box>*/}
                    <Box
                      display="flex"
                      justifyContent="center"
                      sx={{ mb: 2 }}
                    >
                      {loggedInUser && userVoteType ? (
                        <Box
                          sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn": { display: "inline-flex" },
                          }}
                        >
                          <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            //sx={{ mr: 2.3 }}
                            sx={{
                              ml:
                                post.type === "calProp"
                                  ? -1
                                  : post.type === "scotus"
                                  ? -2.3
                                  : 2.3,
                            }}
                          >
                            {/*{post.type === "scotus"
                              ? `Voted ${post.voteType}` // "For Petitioner" / "For Respondent"
                              : `Voted ${post.voteType}`}*/} {/* "Pass" / "No Pass" */}
                            {`Voted ${userVoteType}`}
                          </Button>

                          <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            //sx={{ display: "none", mr: 2.3 }}
                            sx={{
                              display: "none",
                              ml:
                                post.type === "calProp"
                                  ? -1
                                  : post.type === "scotus"
                                  ? -2.3
                                  : 2.3,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrPostType(post.type);
                              setPendingUndoPostId(post._id);
                              setPendingUndoPost(post);
                              setUndoDialogOpen(true);
                            }}
                          >
                            Undo Vote
                          </Button>
                        </Box>
                      ) : (
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{
                            ml:
                              post.type === "calProp"
                                ? -1
                                : post.type === "scotus"
                                ? -2.3
                                : 2.3,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(post._id, post.type);
                          }}
                        >
                          Power Vote
                        </Button>
                      )}
                    </Box>

                    {/* Vote bar with tick */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ mb: 2 }}
                        >
                        <Typography variant="body2">{leftVote}</Typography>


                        {/* Bar with tick in middle */}
                        <Box
                            sx={{
                                position: "relative",
                                height: "2px",
                                backgroundColor: "#ccc",
                                width: "300px",
                                mx: 2
                            }}>
                                {/* Tick in the center */}
                                <Box sx={{
                                    position: "absolute",
                                    top: "-6px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: "2px",
                                    height: "14px",
                                    backgroundColor: "black"
                                }} />
                            
                            {/* Dynamic tick + percentage */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "-6px",
                                    left: `calc(50% + ${offset}%)`,
                                    transform: "translateX(-50%)",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}
                                >
                                {/* Tick */}
                                <Box sx={{
                                    width: "2px",
                                    height: "14px",
                                    backgroundColor: tickColor
                                }} />


                                {/* Percentage */}
                                <Typography
                                    variant="caption"
                                    sx={{ mt: "2px", fontSize: "0.7rem" }}
                                >
                                    {(votePercentage * 100).toFixed(0)}%
                                </Typography>
                                </Box>
                            </Box>
                            <Typography variant="body2">{rightVote}</Typography>
                    </Box>

                    {post.type === "scotus" && (
                            <>
                          {pdfLink && (
                              <Link
                                  href={pdfLink.href}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                              >
                                  {pdfLink.label}
                              </Link>
                          )}
                          </>
                    )}
 
                  {/* Upvote button & count */}
                  <Box mt={2} display="flex" alignItems="center" gap={1}>
                      <Button
                          size="small"
                          variant={post.voted ? "contained" : "outlined"}
                          onClick={(e) => {
                              e.stopPropagation();
                              if (post.type == "bill") {
                                  toggleBillVote(post._id);
                              } else if (post.type == "scotus") {
                                  toggleScotusVote(post._id);
                              } else if (post.type == "stateBill") {
                                  toggleStateBillVote(post._id);
                              } else if (post.type == "calProp") {
                                  toggleCalPropVote(post._id);
                              }
                          }
                        }
                       >
                            ▲ {post.voted ? "Unvote" : "Upvote"}
                      </Button>
                        {/*<Typography variant="body2">{post.upvoteCount} Visibility Upvotes | {voteVar.lCount} {voteVar.lLabel} | {voteVar.rCount} {voteVar.rLabel}</Typography>*/}
                        <Typography variant="body2">
                            {post?.upvoteCount || 0} Visibility Upvotes |{" "}

                            {/* LEFT SIDE VOTE TYPE */}
                            <Box
                              component="span"
                              sx={{ color: "primary.main", }}
                              //sx={{
                              //  cursor: "pointer",
                              //   color: "primary.main", }}
                              //  "&:hover": { textDecoration: "underline" }
                              //}}
                              //onClick={(e) =>
                              //  openVoters(
                              //    e,
                              //    post,
                              //    post.type === "scotus" ? "petitioner" : "noPass"
                              //  )
                              //}
                            >
                              {post.type === "scotus"
                                ? `${post?.petitionerCount || 0} For Petitioner Votes`
                                : `${post?.noPassCount || 0} No Pass Votes`}
                            </Box>

                            {" | "}

                            {/* RIGHT SIDE VOTE TYPE */}
                            <Box
                              component="span"
                              sx={{ color: "primary.main", }}
                              /*sx={{
                                cursor: "pointer",
                                color: "primary.main",
                                "&:hover": { textDecoration: "underline" }
                              }}
                              onClick={(e) =>
                                openVoters(
                                  e,
                                  post,
                                  post.type === "scotus" ? "respondent" : "pass"
                                )
                              }*/
                            >
                              {post.type === "scotus"
                                ? `${post?.respondentCount || 0} For Respondent Votes`
                                : `${post?.passCount || 0} Pass Votes`}
                            </Box>
                        </Typography>

                  </Box>
                  

                  {/* {renderComments(post.comments, null, null, null, post._id, post.type)} */}
                  {renderTopComment(post)}
                  </>
                    )}

                  {isPoll && !isGovPost && (
                    <>
                      <Typography
                          fontWeight="bold"
                          sx={{
                              wordBreak: "break-word",
                              pr: "140px",
                              mb: 1
                          }}
                      >
                          {post.title}
                      </Typography>

                      {/* Centered Vote Button */}
                      <Box
                          display="flex"
                          justifyContent="center"
                          mb={2}
                      >
                          {post.userVote ? (
                              <Box
                                  sx={{
                                      position: "relative",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      "&:hover .voted-btn": {
                                          opacity: 0,
                                      },
                                      "&:hover .undo-btn": {
                                          opacity: 1,
                                          pointerEvents: "auto",
                                      },
                                  }}
                              >
                                  <Button
                                      className="voted-btn"
                                      variant="contained"
                                      color="success"
                                      disabled
                                      sx={{
                                          transition: "opacity 0.2s ease",
                                      }}
                                  >
                                      Voted for {votedOptionLabel}
                                  </Button>


                                  <Button
                                      className="undo-btn"
                                      variant="contained"
                                      color="error"
                                      sx={{
                                          inset: 0,


                                          position: "absolute",
                                          transition: "opacity 0.2s ease",
                                          opacity: 0,
                                          pointerEvents: "none",
                                      }}
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedPost(post);
                                          setUndoDialogOpen(true);
                                      }}
                                  >
                                      Undo Vote
                                  </Button>
                              </Box>
                          ) : (
                              <Button
                                  variant="outlined"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedPost(post);
                                      setOpen(true);
                                  }}
                              >
                                  Power Vote
                              </Button>
                          )}
                      </Box>

                      {/* Results */}
                      <Box>
                          {sortedResults.map(item => (
                              <ResultRow
                                  key={item.id}
                                  item={item}
                                  onVotesClick={(optionId) =>
                                    showVotersForOption(optionId, post)
                                  }
                              />
                          ))}
                      </Box>

                      {/* Dialog */}
                      {/*<VoteDialog
                          open={open}
                          onClose={() => setOpen(false)}
                          options={selectedPost?.options}
                          pollId={selectedPost?._id}
                          onVoted={updatedPoll => setPoll(updatedPoll)}
                          post={selectedPost}
                      />*/}
                     {/* {renderComments(post.comments, null, null, null, post._id, post.type)} */}
                     {renderTopComment(post)}
                    </>
                  )}

                  {isGovPost && (
                    <>
                    <Box display="flex" alignItems="flex-start" gap={1}>
                      <Avatar
                          src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                          alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                          onClick={(e) => visitProfile(e, post.author?._id)}
                          sx={{
                           width: 62,
                           height: 62,
                           cursor: "pointer",
                           "&:hover": {
                               backgroundColor: "#d9e4f0",
                           },
                           }}
                      />
                      <Box>
                          <Typography
                               variant="subtitle1"
                               fontWeight="bold"
                               onClick={(e) => visitProfile(e, post.author?._id)}
                               sx={{
                                   cursor: "pointer",
                                   display: "inline-block",
                                   "&:hover": {
                                   textDecoration: "underline",
                                   textDecorationColor: "currentColor",
                                   textUnderlineOffset: "3px",
                                   },
                               }}
                           >
                               {post.author?.first_name && post.author?.last_name
                                   ? `${post.author.first_name} ${post.author.last_name}`
                                   : 'Unknown Name'}
                          </Typography>
                          <Typography
                               variant="body2"
                               color="text.secondary"
                               onClick={(e) => visitProfile(e, post.author?._id)}
                               sx={{
                                   cursor: "pointer",
                                   display: "block",
                                   "&:hover": {
                                   textDecoration: "underline",
                                   textDecorationColor: "#currentColor",
                                   textUnderlineOffset: "3px",
                                   },
                               }}
                           >
                               @{post.author?.username || 'unknown'}
                          </Typography>
                          <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                              {post.content}
                          </Typography>
                           {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                               {`${new Date(post.created_at).toLocaleString()}, ${post.commentCount || post.replyCount} ${
                                   post.commentCount === 1 || post.replyCount == 1 ? 'reply' : 'replies'
                               }`}
                           </Typography>*/}
                           <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                              {`${new Date(post.created_at).toLocaleString()}, ${
                                post.commentCount ?? post.replyCount ?? 0
                              } ${
                                (post.commentCount ?? post.replyCount ?? 0) === 1 ? 'reply' : 'replies'
                              }`}
                           </Typography>


                      </Box>
                  </Box>
                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                       {post.voted ? (
                           <Box
                              sx={{
                                  position: "relative",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  "&:hover .voted-btn": {
                                      opacity: 0,
                                  },
                                  "&:hover .undo-btn": {
                                      opacity: 1,
                                      pointerEvents: "auto",
                                  },
                              }}
                          >
                               <Button
                                   size="small"
                                   className="voted-btn"
                                   variant="contained"
                                   color="success"
                                   disabled
                                   sx={{
                                      transition: "opacity 0.2s ease",
                                   }}
                               >
                                  Power Voted
                              </Button>
                              <Button
                                   size="small"
                                   className="undo-btn"
                                   variant="contained"
                                   color="error"
                                   sx={{
                                      inset: 0,
                                      position: "absolute",
                                      transition: "opacity 0.2s ease",
                                      opacity: 0,
                                      pointerEvents: "none",
                                  }}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      toggleVote(post._id)
                                  }}
                              >
                                   Undo
                              </Button>
                          </Box>
                       ) : (
                           <Button
                               size="small"
                               variant="outlined"
                               onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(post._id)
                              }
                           }
                           >
                               ▲ Power Vote
                           </Button>
                       )}
                       <Typography variant="body2">{post.upvotes || post.upvoteCount} Power Votes</Typography>
                  </Box>
                    </>
                  )}

                  </Box>
                  
                );
                
              })}
              <VoteDialog
                          open={open}
                          onClose={() => setOpen(false)}
                          options={selectedPost?.options}
                          pollId={selectedPost?._id}
                          //onVoted={updatedPoll => setPoll(updatedPoll)}
                          /*onVoted={(updatedPoll) => {
                            setGovComments(prev =>
                              prev.map(p =>
                                p._id === updatedPoll._id ? updatedPoll : p
                              )
                            );
                          }}*/
                         onVoted={(updatedPoll) => {
                            setGovComments(prev =>
                              prev.map(p =>
                                p._id === updatedPoll._id
                                  ? {
                                      ...p,
                                      userVote: updatedPoll.userVote,
                                      options: updatedPoll.options, 
                                    }
                                  : p
                              )
                            );
                          }}
                          post={selectedPost}
                      />

              {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
               <DialogTitle>Cast Your Power Vote</DialogTitle>
               <DialogContent>
                   <Box display="flex" gap={2} mb={2}>
                       <Button
                           variant={voteType === "Pass" ? "contained" : "outlined"}
                           onClick={() => setVoteType("Pass")}
                       >
                           Pass
                       </Button>
                       <Button
                           variant={voteType === "No Pass" ? "contained" : "outlined"}
                           onClick={() => setVoteType("No Pass")}
                       >
                           No Pass
                       </Button>
                   </Box>
                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
               </DialogContent>
               <DialogActions>
                   <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                   <Button
                       variant="outlined"
                       onClick={ () => {
                        if (currPostType == "bill") {
                            handleSubmitBillVote()
                        } else if (currPostType == "scotus") {
                            handleSubmitScotusVote()
                        } else if (currPostType == "stateBill") {
                            handleSubmitStateBillVote()
                        } 
 		                   }}
                        disabled={!comment || !voteType}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>*/}
           {/* --- Dialog --- */}
           <Dialog 
              open={openDialog} 
              onClose={() => setOpenDialog(false)} 
              fullWidth
              PaperProps={{
                  sx: {
                  backgroundColor: "#FFFDF8",
                  borderRadius: 3,
                  },
              }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
                  <DialogContent>
                      <Box display="flex" gap={2} mb={2}>
                          {currPostType === "scotus" ? (
                              <>
                                <Button
                                  variant={voteType === "For Petitioner" ? "contained" : "outlined"}
                                  onClick={() => setVoteType("For Petitioner")}
                                >
                                  For Petitioner
                                </Button>
                                <Button
                                  variant={voteType === "For Respondent" ? "contained" : "outlined"}
                                  onClick={() => setVoteType("For Respondent")}
                                >
                                  For Respondent
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  variant={voteType === "No Pass" ? "contained" : "outlined"}
                                  onClick={() => setVoteType("No Pass")}
                                >
                                  No Pass
                                </Button>
                                <Button
                                  variant={voteType === "Pass" ? "contained" : "outlined"}
                                  onClick={() => setVoteType("Pass")}
                                >
                                  Pass
                                </Button>
                              </>
                            )}
                      </Box>
                      <TextField
                          fullWidth
                          multiline
                          rows={3}
                          placeholder="Explain your power vote (required)"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                      />
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                      <Button
                          variant="outlined"
                          onClick={ () => {
                            if (currPostType == "bill") {
                                handleSubmitBillVote()
                            } else if (currPostType == "scotus") {
                                handleSubmitScotusVote()
                            } else if (currPostType == "stateBill") {
                                handleSubmitStateBillVote()
                            } 
                          }}
                          disabled={!comment || !voteType}
                      >
                          Submit Power Vote
                      </Button>
                  </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>
                   {(currPostType === "bill" || currPostType == "scotus" || currPostType == "stateBill" ) ? (
                      <Button
                          onClick={() => {
                              handleUndoVote(pendingUndoPostId, pendingUndoPost);
                              setUndoDialogOpen(false);
                              setPendingUndoPostId(null);
                              setPendingUndoPost(null);
                          }}
                          variant="contained"
                          color="error"
                          sx={{
                              boxShadow: "none",
                          }}
                      >
                          Yes, Undo Vote
                      </Button>
                   ) : (
                      <Button
                               onClick={async () => {
                                   await undoElectionVote(selectedPost);     
                                   setUndoDialogOpen(false);
                               }}   
                               variant="contained"
                               color="error"
                               sx={{
                                   boxShadow: "none",
                               }}
                           >
                               Yes, Undo Vote
                           </Button>
                   )}
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* list of voters */}
                   <Dialog
                       open={votersDialogOpen}
                       onClose={() => setVotersDialogOpen(false)}
                       fullWidth
                       maxWidth="xs"
                       PaperProps={{
                           sx: {
                               backgroundColor: "#FFFDF8",
                               borderRadius: 3,
                           },
                       }}
                   >
                       <DialogTitle sx={{ fontWeight: 600 }}>
                           Voters
                       </DialogTitle>

                       <DialogContent dividers>
                           {selectedOptionVoters.length === 0 ? (
                           <Typography variant="body2" color="text.secondary">
                               No votes
                           </Typography>
                           ) : (
                           <List disablePadding>
                               {selectedOptionVoters.map(vote => (
                               <ListItem
                                   key={vote.user._id}
                                   button
                                   onClick={(e) => visitProfile(e, vote.user._id)}
                                   sx={{
                                       px: 0,
                                       borderRadius: 2,
                                       cursor: 'pointer',
                                       transition: 'background-color 0.2s',
                                       '&:hover': {
                                           backgroundColor: '#FFF2CC', // subtle highlight
                                       },
                                   }}
                               >
                                   <Box
                                       sx={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           justifyContent: 'space-between',
                                           width: '100%',
                                       }}
                                   >
                                       {/* Left side: Avatar + user info */}
                                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                           <ListItemAvatar>
                                           <Avatar src={vote.user.profileImageUrl}>
                                               {vote.user.username?.[0]}
                                           </Avatar>
                                           </ListItemAvatar>
                                           <ListItemText
                                               primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                               secondary={`@${vote.user.username}`}
                                           />
                                       </Box>
                                       <Typography variant="body2" color="text.secondary">
                                           Voting Power: {vote.user.tier}
                                       </Typography>
                                   </Box>
                               </ListItem>
                               ))}
                           </List>
                           )}
                       </DialogContent>

                       <DialogActions>
                           <Button onClick={() => setVotersDialogOpen(false)}>
                               Close
                           </Button>
                       </DialogActions>
                   </Dialog>

    </div>
  );
}


export default Page2SubPageD;
